import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-scroll-search-college',
  templateUrl: './scroll-search-college.component.html',
  styleUrls: ['./scroll-search-college.component.scss']
})
export class ScrollSearchCollegeComponent implements OnInit {

  items: Array<any> = [];
  user: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  busyGet: Subscription;
  searchKeyCollege: any = "";
  college_id: any
  @Input() police_id: any;
  @Input() current_college_id: any;
  @Input() clearText: any;
  @Output() onSelectCollege = new EventEmitter();
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.police_id && changes.police_id.currentValue) {
      this.police_id = changes.police_id.currentValue;
    }

    if (changes.current_college_id && changes.current_college_id.currentValue) {
      this.college_id = changes.current_college_id.currentValue;
    }
    if (changes.clearText && changes.clearText.currentValue) {
      this.clearSelection()
    }
    this.itemsPerPage = 10
    this.getItems()
  }
  onSearch(event) {
    console.log("fkdkfjkd", event);
    this.itemsPerPage = 10;
    this.searchKeyCollege = event.term;
    if (event.term.length)
      this.getItems();
  }

  clearSelection() {
    this.college_id = null; // or undefined
    this.items = []
    this.searchKeyCollege = ''
  }


  onGetMoreItems() {
    this.itemsPerPage += 5;
    this.getItems();
  }


  onSelectElement() {

    this.onSelectCollege.emit(this.college_id)

  }

  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: this.itemsPerPage,
      search_key: this.searchKeyCollege,
      data: {
        // reseau_de_soin_id: this.reseau_de_soin_id,
        police_id: this.police_id,
      },
    };

    this.busyGet = this.restClient
      .post("college/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.items = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.items = [];
          }
        },
        (err) => {
          this.items = [];
        }
      );
  }



  onSelectTypePrestataire() { }

  ngOnInit() {
  }
}
